import { CSVImport, type ColumnMapping } from '../shared/CSVImport';

const STUDENT_FIELDS: ColumnMapping[] = [
  { csvHeader: '', targetField: 'firstName', required: true },
  { csvHeader: '', targetField: 'lastName', required: true },
  { csvHeader: '', targetField: 'clientId', required: true },
  { csvHeader: '', targetField: 'grade' },
  { csvHeader: '', targetField: 'status', required: false },
];

export const StudentImport = () => (
  <CSVImport resourceName="students" targetFields={STUDENT_FIELDS} />
);
